module.exports = __webpack_public_path__ + "static/media/act03.685c429e.mpeg";